/**
 * Web shim for expo-haptics
 *
 * Haptic feedback is native-only. All methods are no-ops on web.
 */

const ImpactFeedbackStyle = { Light: 'light', Medium: 'medium', Heavy: 'heavy' };
const NotificationFeedbackType = { Success: 'success', Warning: 'warning', Error: 'error' };

module.exports = {
  __esModule: true,
  impactAsync: async () => {},
  notificationAsync: async () => {},
  selectionAsync: async () => {},
  ImpactFeedbackStyle,
  NotificationFeedbackType,
};

module.exports.default = module.exports;
